import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause",
  "use": "pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pause\"><defs><style>#pause .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}</style></defs><path class=\"a\" d=\"M9.75 8.248v7.5M14.805 8.248v7.5\" /><circle class=\"a\" cx=\"12\" cy=\"11.998\" r=\"11.25\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol